import styled from 'styled-components'
import Icon from '@/components/common/Icon'

const AdsIconButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  cursor: pointer;
  width: 44px;
  height: 44px;
  transition: background 0.26s ease-in-out;

  &:hover {
    background: rgba(255, 255, 255, 0.5);
  }
`

const AdsIconButton = styled(Icon)`
  transition: transform 0.4s ease-in-out;
  background: var(--white);
  width: 24px;
  height: 24px;
`

export const WrappedAdsIconButton = ({ icon }) => (
  <AdsIconButtonWrapper>
    <AdsIconButton icon={icon} c />
  </AdsIconButtonWrapper>
)

export default WrappedAdsIconButton
